import React from "react";
import { Link } from "react-router-dom";
import { GoChevronRight } from "react-icons/go";

const path = "";

function HomeContact() {

    return (
        <section id="homeContact">
            <div className="container">
                <div className="homeContactMain">
                    <div className="homeContactCol1">
                        <h2 className="title">Dear job seeker's</h2>
                        <h3 className="mainTitle">Accelerate Your Career With Us</h3>
                    </div>
                    <div className="homeContactCol2">
                        <Link to={`${path}/contact`}>Connect Now <GoChevronRight /></Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HomeContact;
